import { ActionGenreChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreActionGenre } from '@types';

const initialState: IStoreActionGenre = {
  childOptionValue: ActionGenreChildOptionValueEnum.펀치
};

export const actionGenreSlice = createSlice({
  name: 'actionGenre',
  initialState,
  reducers: {
    initActionGenre: () => {
      return initialState;
    },

    setActionGenre: (state, action: PayloadAction<IStoreActionGenre>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initActionGenre, setActionGenre } = actionGenreSlice.actions;

export default actionGenreSlice.reducer;
